import { defineStore } from "pinia";

export const useLocaleStore = defineStore("locale", {
  state: () => ({
    value: 'zh-CN' as 'zh-CN' | 'en'
  }),
  actions: {
    changeLang(lang: 'zh-CN' | 'en') {
      this.value = lang;
      location.reload();
    }
  }
});

export const useUserStore = defineStore("user", {
  state: () => ({
    username: undefined,
    token: undefined,
  } as { username: string, token: string; } | { username: undefined, token: undefined; }),
  getters: {
    isSignedIn({ token }): boolean {
      return Boolean(token);
    },
  },
});
